import React  from 'react';
import PropTypes from 'prop-types';

const HelpIcon = (props) => {
  const { width, height, isActive } = props;
  let color;
  if (!isActive) {
    color = '#AEB2BF';
  }
  else {
    color = '#FF4200';
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 25">
      <path fill={color} d="M12 .142c-6.617 0-12 5.383-12 12s5.383 12 12 12 12-5.383 12-12-5.383-12-12-12zm-.5 19a1.5 1.5 0 1 1 .001-3 1.5 1.5 0 0 1-.001 3zm4.311-8.873c-.309.495-.896 1.051-1.762 1.67-1.401 1.035-1.363 1.265-1.363 2.203h-2.457c0-.733-.016-1.296.38-1.98.253-.44.717-.907 1.391-1.4.809-.579 1.595-1.136 1.595-2.106 0-.909-.778-1.233-1.687-1.233-.927 0-1.984.303-3.171.91l-1.011-2.03c2.157-1.21 5.561-1.757 7.422-.242 1.366 1.113 1.374 3.07.663 4.208z"/>
    </svg>
  );
};

HelpIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isActive: PropTypes.bool,
};

HelpIcon.defaultProps = {
  width: 24,
  height: 25,
  isActive: false,
};

export default HelpIcon;
